export default __webpack_public_path__ + "static/media/voyageLogo.db6a114d.png";